const colorFondo = "white";

export const tituloStyle = {
    fontSize: '25px',
    overflow: 'hidden',
    position: 'fixed',
    top: 0,
    width: '100%',
    boxSizing: "border-box",
    padding: '8px 16px 0px 16px',
    backgroundColor: colorFondo,
    zIndex: 9999,
    textAlign: 'left'
}

export function contenidoStyle (top) {
    return {
        top,
        position: 'relative',
        padding: '0px 16px 16px 16px',
    }
}

export const seccionTituloStyle = {
    textAlign: "left",
    fontSize: "30px",
    fontWeight: "bold",
    paddingBottom: "8px",
}

export const seccionSeccionesPadreStyle = {
    textAlign: "right",
    fontSize: "18px",
    fontWeight: "bold",
    paddingBottom: "8px"
}

export const seccionContenidoStyle = {
    textAlign: "left",
    fontSize: "20px",
    paddingBottom: "8px"
}

export const seccionComentariosStyle = {
    textAlign: "left",
    fontSize: "18px",
    paddingTop: "10px"
}

export const seccionAntSigStyle = {
    fontSize: "18px",
    paddingTop: "10px"
}

export const listaSeccionesStyle = {
    listStyleType: "disc",
    margin: 0,
    padding: 0,
    fontSize: "18px"
    // whiteSpace: "nowrap",
    // textOverflow: "ellipsis",
    // overflow: "hidden !important",
    // maxWidth: "100%"
}